import _ from 'underscore';

/**
 * Default function to examine a location and determines if it is eligible as a boundary target.
 * Logic taken from legacy file geoConverter.js.
 * @param {Object} location - Location to check.
 * @returns {Boolean} - True if it should be a radius target.
 */
export function getIsBoundaryTarget(location) {
  if (location == null) {
    return false;
  }

  if (_.isFinite(location.Id) && location.Id > 0) {
    // MT odata LocationId is required for boundary targeting
    return true;
  }

  return false;
}
